import {
  ADD_NEW_MANIFOLD_MAIN,
  CALCULATIONS_SET_MANIFOLD_SEPARATIONS,
  CHAMBERS_ISOLATOR_CLEAN,
  CHANGE_MANIFOLD_PROP_MAIN,
  CLEAN_END_GENERATION,
  CLEAR_MANIFOLD_MAIN,
  INLET_MANIFOLD_ID, IS_DIRTY,
  MANIFOLD_RENDER_LOWER,
  MANIFOLD_RENDER_MAIN,
  OUTLET_MANIFOLD_ID,
  REMOVE_BY_IDS_MANIFOLD_MAIN
} from "../lib/types";
import {
  getManifoldBendSeparation,
  getManifoldEndCapSeparation,
  getManifoldSizing,
  getManifoldTrunkSeparation,
  Manifold
} from "../lib/manifolds";
import { getScaledValue } from "../lib/calculations";
import { cloneChamberRows } from "../lib/chamber-row";
import { getStructureTypesByVolume, ManifoldUtils } from "../lib/manifolds/utils";
import ManifoldService from "../lib/services/manifold-service";
import ChamberService from "../lib/services/chambers-service";

/**
 *  Upper Manifold Rendering
 * @param chamberRows
 * @param manifolds
 * @returns {function(...[*]=)}
 */
export const renderUpperManifolds = ( chamberRows, manifolds ) => ( dispatch, getState ) => {
  const state = getState();
  const { chamberType, chamberRowSpacing } = state.globals;
  console.error(`
    ***********************************************
    ** renderUpperManifolds() should nopt be used, 
    ** change it to  renderMainManifolds(()
    ***********************************************
    `);
  dispatch({
    type: MANIFOLD_RENDER_MAIN,
    payload: {
      chamberRows,
      manifolds,
      chamberType,
      chamberRowSpacing
    }
  });
};

/**
 * Lower Manifold Rendering
 * @param chamberRows
 * @param manifolds
 * @returns {function(...[*]=)}
 */
export const renderLowerManifolds = ( chamberRows, manifolds ) => ( dispatch, getState ) => {
  const s = getState();
  const { chamberType, chamberRowSpacing } = s.globals;
  console.error(`
    ***********************************************
    ** renderLowerManifolds() should nopt be used, 
    ** change it to  renderMainManifolds(()
    ***********************************************
    `);
  dispatch({
    type: MANIFOLD_RENDER_LOWER,
    payload: {
      chamberRows,
      manifolds,
      chamberType,
      chamberRowSpacing
    }
  });
};

/**
 * All Manifolds Rendering
 * @param chamberRows
 * @param manifolds
 * @param refreshManifold {boolean}
 * @returns {function(...[*]=)}
 */
export const renderMainManifolds = ( chamberRows, manifolds, refreshManifold = false ) => ( dispatch, getState ) => {
  const state = getState();
  const { chamberType, chamberRowSpacing } = state.globals;
  const { totalStorageProvided } = state.calculations;
  const chamberbed = state.chamberbed;

  console.error("renderMainManifolds() should not be used anymore");

  dispatch({
    type: MANIFOLD_RENDER_MAIN,
    payload: {
      chamberRows,
      manifolds,
      chamberType,
      chamberRowSpacing,
      totalStorageProvided,
      chamberbed,
      refreshManifold
    }
  });
};


export const getSingleManifoldMetadata = ( row, col, chamberRows, state ) => {
  try {
    const { globals, calculations, mainManifolds: existingManifolds } = state;
    const { chamberType, chamberRowSpacing } = globals;
    const {
      forceManifoldSpacer,
      storageVolume,
      generateSystem: isGeneratingSystem,
      totalStorageProvided
    } = calculations;
    let mainManifolds = [];
    const getIsRowOffset = ( structureType, structureSize ) => {
      try {
        const manifoldMetadata = ManifoldUtils.getManifoldMetadataByTypeAndSize(structureType, structureSize);
        return manifoldMetadata && ( manifoldMetadata.outerDiameter / 12 ) / 2 > chamberType.width / 2 + chamberRowSpacing;
      } catch (exception) {
        console.info(`manifold-actions.js getSingleManifoldMetadata() > getIsRowOffset() :: ${exception.message}`);
        return false;
      }
    };
    const chamberRowsArray = cloneChamberRows(chamberRows);
    // TODO This forEach should be removed
    chamberRowsArray.forEach(( chamberRow, rowIdx ) => {
      let chambers = chamberRow.chambers;
      chambers
        .forEach(( chamber, chamberIdx ) => {
          const isChamberTypeObj = ChamberService.isChamberType(chamber, chambers.length, chamberIdx);
          if (isChamberTypeObj !== undefined) {
            const producedManifold = ChamberService
              .processManifoldOnChamber(
                isChamberTypeObj.type,
                isChamberTypeObj.isUpper,
                chamber,
                existingManifolds,
                chamberType,
                totalStorageProvided,
                storageVolume,
                chamberRow,
                forceManifoldSpacer, //null,
                isGeneratingSystem,
                getIsRowOffset,
                isChamberTypeObj.isInnerChamber
              );
            mainManifolds.push(producedManifold);
          }
        });
    });

    return mainManifolds.find(
      manifold => {
        return manifold.letRow === row && manifold.letColumn === col;
      });
  } catch (exception) {
    console.info(`manifold-actions.js getSingleManifoldMetadata() :: ${exception.message}`);
  }
  return {};
};

export const createMainManifold = ( row, col, manifold = null, flip = false ) => ( dispatch, getState ) => {
  const state = getState();
  const { chamberType, chamberRowSpacing } = state.globals;
  const { totalStorageProvided } = state.calculations;
  const chamberbed = state.chamberbed;
  let electedManifoldMetadata = getSingleManifoldMetadata(row, col, chamberbed.chamberRows, state);

  dispatch({
    type: ADD_NEW_MANIFOLD_MAIN,
    payload: {
      chamberRows: chamberbed.chamberRows,
      electedManifoldMetadata,
      chamberType,
      chamberRowSpacing,
      totalStorageProvided,
      chamberbed,
      refreshManifold: false,
      manifold,
      flip
    }
  });

  dispatch({
    type: IS_DIRTY,
    payload: true
  });
};

/**
 *
 * @param manifoldId
 * @param value
 * @param type
 * @returns {function(*, *): void}
 */
export const changeMainManifoldProp = ( manifoldId, value, type ) => ( dispatch, getState ) => {

  const state = getState();
  const { chamberType, chamberRowSpacing } = state.globals;
  const { totalStorageProvided } = state.calculations;
  const chamberbed = state.chamberbed;
  const manifolds = state.mainManifolds.manifolds;
  const manifold = manifolds.find(manifold => manifold._id === manifoldId);
  let electedManifoldMetadata = {};
  try {
    electedManifoldMetadata = getSingleManifoldMetadata(manifold._letRow, manifold._letColumn, chamberbed.chamberRows, state);
  } catch (e) { // Nothing to do, this acts on an un existing manifold, when resizing bed, returns a _letRow undefined
  }


  dispatch({
    type: CHANGE_MANIFOLD_PROP_MAIN,
    payload: {
      manifoldId,
      value,
      type,
      chamberType,
      chamberRowSpacing,
      totalStorageProvided,
      chamberbed,
      electedManifoldMetadata
    }
  });

  dispatch({
    type: IS_DIRTY,
    payload: true
  });
};

export const removeMainManifoldsByArrayOfId = ( arrayOfManifoldIds ) => ( dispatch ) => {
  if (arrayOfManifoldIds && arrayOfManifoldIds.length > 0) {
    const manifoldsIdsSimplified = arrayOfManifoldIds
      .map(manifold => {
        return {
          manifoldId: manifold._id,
          row: manifold._letRow,
          col: manifold._letColumn
        };
      });

    // remove manifolds
    dispatch({
      type: REMOVE_BY_IDS_MANIFOLD_MAIN,
      payload: {
        manifoldsIdsSimple: manifoldsIdsSimplified
      }
    });

    // Remove isolators by manifold
    manifoldsIdsSimplified
      .forEach(manifoldSimplified => {
        dispatch({
          type: CHAMBERS_ISOLATOR_CLEAN,
          payload: {
            manifoldId: manifoldSimplified.manifoldId,
            actualRow: manifoldSimplified.row,
            actualCol: manifoldSimplified.col
          }
        });
      });

    dispatch({
      type: IS_DIRTY,
      payload: true
    });
  }
};

export const clearMainManifoldsState = () => ( dispatch ) => {
  dispatch({
    type: CLEAR_MANIFOLD_MAIN
  });
  dispatch({
    type: IS_DIRTY,
    payload: true
  });
};


export const clearBuildGenerationFlag = () => dispatch => {
  dispatch({
    type: CLEAN_END_GENERATION
  });
};

/**
 * Generates Manifold metadata used to build manifolds structures
 * @param chamberRows
 * @returns {function(...[*]=)}
 */
export const getManifoldMetadata = chamberRows => ( dispatch, getState ) => {
  try {
    const { globals, calculations, mainManifolds: existingManifolds } = getState();
    const { chamberType, chamberRowSpacing } = globals;
    const { forceManifoldSpacer, storageVolume, generateSystem: isGeneratingSystem, totalStorageProvided } = calculations;
    let upperManifolds = [];
    let lowerManifolds = [];
    let mainManifolds = [];
    const getIsRowOffset = ( structureType, structureSize ) => {
      try {
        const manifoldMetadata = ManifoldUtils.getManifoldMetadataByTypeAndSize(structureType, structureSize);
        return manifoldMetadata && ( manifoldMetadata.outerDiameter / 12 ) / 2 > chamberType.width / 2 + chamberRowSpacing;
      } catch (exception) {
        console.warn(`At manifold-actions.js getIsRowOffset() :: Unable to find row offset ${exception.message}`);
        return false;
      }
    };
    const chamberRowsArray = cloneChamberRows(chamberRows);
    chamberRowsArray.forEach(( chamberRow, rowIdx ) => {
      let chambers = chamberRow.chambers;
      chambers
        .forEach(( chamber, chamberIdx ) => {
          const isChamberTypeObj = ChamberService.isChamberType(chamber, chambers.length, chamberIdx);
          if (isChamberTypeObj !== undefined) {
            const producedManifold = ChamberService
              .processManifoldOnChamber(
                isChamberTypeObj.type,
                isChamberTypeObj.isUpper,
                chamber,
                existingManifolds,
                chamberType,
                totalStorageProvided,
                storageVolume,
                chamberRow,
                forceManifoldSpacer,
                isGeneratingSystem,
                getIsRowOffset,
                isChamberTypeObj.isInnerChamber
              );
            mainManifolds.push(producedManifold);
          }
        });
    });
    return { upperManifolds, lowerManifolds, mainManifolds };

  } catch (exception) {
    console.warn(`At manifold-actions.js getManifoldMetadata() :: Unable to create manifolds ${exception.message}`, exception);
  }

  return { upperManifolds: [], lowerManifolds: [], mainManifolds: [] };
};

/**
 * Gets Manifolds
 * @param chamberRows
 * @param manifolds
 * @param isUpper
 * @returns {function(*, *): *}
 */
export const getManifolds = ( chamberRows, manifolds, isUpper ) => ( dispatch, getState ) => {
  let state = getState().upperManifolds;

  if (!isUpper) state = getState().lowerManifolds;

  let isUpperManifold = isUpper;
  const newManifolds = manifolds
    .map(propertiesObj => {

      let manifoldOffset = propertiesObj.manifoldOffset;
      const thisManifoldsRow = chamberRows[propertiesObj.letRow];
      let { offSet } = chamberRows[propertiesObj.letRow];

      if (propertiesObj.manifoldType) {
        isUpperManifold = ( propertiesObj.manifoldType === "upper" );
      }

      let structureType;

      thisManifoldsRow.chambers
        .forEach(chamber => {
          if (
            chamber &&
            chamber.upperCapActive &&
            chamber.upperCapAccessory
          ) {
            if (
              chamber.upperCapAccessory.id === INLET_MANIFOLD_ID ||
              chamber.upperCapAccessory.id === OUTLET_MANIFOLD_ID
            ) {
              structureType = chamber.upperCapAccessory.variant;
            }
          }
          if (
            chamber &&
            chamber.lowerCapActive &&
            chamber.lowerCapAccessory
          ) {
            if (
              chamber.lowerCapAccessory.id === INLET_MANIFOLD_ID ||
              chamber.lowerCapAccessory.id === OUTLET_MANIFOLD_ID
            ) {
              structureType = chamber.lowerCapAccessory.variant;
            }
          }
        });


      let structureSize = ( propertiesObj.manifoldSize )[structureType === "nyloplast"
        ? "nyloplastStructureSize"
        : "concreteStructureSize"];


      manifoldOffset = false;

      const currentChamberCoordinates = {
        row: propertiesObj.letRow,
        col: propertiesObj.letColumn
      };

      const isManifoldInner = ManifoldService.isManifoldInnerOnChamberRow(currentChamberCoordinates, chamberRows);


      let manifoldTypeId = ( propertiesObj.isInlet )
        ? "INLET_MANIFOLD_ID"
        : "OUTLET_MANIFOLD_ID";


      const constructPlacement = {};


      const removeSecondPipe = propertiesObj.hasSecondPipe && ( isUpperManifold
        ? !thisManifoldsRow.chambers.find(c => c.col < propertiesObj.letColumn && c.active)
        : !thisManifoldsRow.chambers.find(c => c.col > propertiesObj.letColumn && c.active) );


      return new Manifold(
        propertiesObj.id,
        propertiesObj.isInlet,
        offSet,
        propertiesObj.letRow,
        propertiesObj.letColumn,
        propertiesObj.direction,
        propertiesObj.stubsNumber,
        propertiesObj.spacer,
        propertiesObj.isElevated,
        propertiesObj.hasWeir,
        isUpperManifold,
        propertiesObj.userModified,
        propertiesObj.manifoldSize,
        propertiesObj.manifoldType,
        isManifoldInner,
        {
          mainRow: [],  // TODO this should be fixed
          voidRows: []
        },
        ( propertiesObj.hasSecondPipe && removeSecondPipe ? false : propertiesObj.hasSecondPipe ),
        propertiesObj.hasIsolator,
        true
      ).assemble(
        chamberRows,
        manifoldOffset,
        state.extraInletStubs,
        state.extraOutletStubs,
        false,
        isUpperManifold,
        currentChamberCoordinates,
        constructPlacement
      );
    });

  return newManifolds;
};

/**
 * Setts manifolds separations
 * @param storageVolume
 * @returns {function(*=, *=): {manifoldSeparations: {default: {square: number, round: number, nyloplast: number}, collapsedInletIsolator: {square: number, round: number, nyloplast: number}, inletIsolator: {square: number, round: number, nyloplast: number}, bendSeparation: number, endCapSeparation: number, collapsedDefault: {square: number, round: number, nyloplast: number}, collapsedOutlet: {square: number, round: number, nyloplast: number}, outlet: {square: number, round: number, nyloplast: number}}, manifoldSizing: {}}}
 */
export const applyManifoldSeparations = storageVolume => ( dispatch, getState ) => {
  const result = calculateManifoldSeparations(storageVolume)(dispatch, getState);

  dispatch({
    type: CALCULATIONS_SET_MANIFOLD_SEPARATIONS,
    payload: result
  });

  return result;
};

/**
 * Checks if the Manifold structure has changed
 * @param oldChamberType
 * @param newChamberType
 * @returns {function(...[*]=)}
 */
export const hasManifoldInletOutletStructureChanged = ( oldChamberType, newChamberType ) => ( dispatch, getState ) => {
  let result = {
    didDefaultInletStructureChange: false,
    didDefaultOutletStructureChange: false
  };

  try {
    const { calculations, upperManifolds: _upperManifolds, lowerManifolds: _lowerManifolds } = getState();
    const { storageVolume, totalStorageProvided } = calculations;
    const { manifolds: upperManifolds } = _upperManifolds;
    const { manifolds: lowerManifolds } = _lowerManifolds;
    const volume = totalStorageProvided || storageVolume;
    const { manifoldSizing: prevManifoldSizing } = calculateManifoldSeparations(volume, oldChamberType)(dispatch, getState);
    const hasInlet = upperManifolds.some(manifold => manifold.isInlet) || lowerManifolds.some(manifold => manifold.isInlet);
    const hasOutlet = upperManifolds.some(manifold => manifold.isOutlet) || lowerManifolds.some(manifold => manifold.isOutlet);
    const {
      inletStructureType: defaultInletType,
      outletStructureType: defaultOutletType
    } = getStructureTypesByVolume(volume, newChamberType);
    const didDefaultInletStructureChange = hasInlet && prevManifoldSizing.inletStructureType !== defaultInletType;
    const didDefaultOutletStructureChange = hasOutlet && prevManifoldSizing.outletStructureType !== defaultOutletType;

    return {
      didDefaultInletStructureChange: didDefaultInletStructureChange,
      didDefaultOutletStructureChange: didDefaultOutletStructureChange
    };
  } catch (exception) {
    console.warn("An issue occurred checking for inlet/outlet structure change", exception);
  }

  return result;
};

/**
 * Manifolds Separation Calculation - Calculates the distance between elements
 * @param storageVolume
 * @param providedChamberType
 * @returns {function(*, *): {manifoldSeparations: {default: {square: number, round: number, nyloplast: number}, collapsedInletIsolator: {square: number, round: number, nyloplast: number}, inletIsolator: {square: number, round: number, nyloplast: number}, bendSeparation: number, endCapSeparation: number, collapsedDefault: {square: number, round: number, nyloplast: number}, collapsedOutlet: {square: number, round: number, nyloplast: number}, outlet: {square: number, round: number, nyloplast: number}}, manifoldSizing: {}}}
 */
export const calculateManifoldSeparations = ( storageVolume, providedChamberType = null ) => ( dispatch, getState ) => {
  let manifoldSeparations = {
    default: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    inletIsolator: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    outlet: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    collapsedDefault: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    collapsedInletIsolator: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    collapsedOutlet: {
      round: 0,
      square: 0,
      nyloplast: 0
    },
    bendSeparation: 0,
    endCapSeparation: 0
  };

  let manifoldSizing = {};

  try {
    const { globals, stonebed } = getState();
    const { scalePixels, scaleValue, chamberRowSpacing } = globals;
    const { sepDistance, manifoldStructures, manifoldPipeSizes } = stonebed;
    const chamberType = providedChamberType !== null ? providedChamberType : globals.chamberType;

    manifoldSizing = getManifoldSizing(storageVolume, chamberType);

    const
      DEFAULT_ENDCAP_INDEX = 0,
      INLET_ISOLATOR_ENDCAP_INDEX = 2,
      OUTLET_ENDCAP_INDEX = 3;

    if (manifoldSizing && manifoldStructures) {
      const { round, square, nyloplast } = manifoldStructures;
      const _getManifoldSeparationRound = getManifoldTrunkSeparation.bind(
        null,
        round[0],
        manifoldSizing,
        manifoldPipeSizes
      );
      const _getManifoldSeparationSquare = getManifoldTrunkSeparation.bind(
        null,
        square[0],
        manifoldSizing,
        manifoldPipeSizes
      );
      const _getManifoldSeparationNyloplast = getManifoldTrunkSeparation.bind(
        null,
        nyloplast[0],
        manifoldSizing,
        manifoldPipeSizes
      );
      const _getScaledValue = ( fnc, endCapIndex, collapsed = false ) => getScaledValue(scalePixels, scaleValue, fnc(endCapIndex, sepDistance, collapsed));

      manifoldSeparations.default = {
        round: _getScaledValue(_getManifoldSeparationRound, DEFAULT_ENDCAP_INDEX),
        square: _getScaledValue(_getManifoldSeparationSquare, DEFAULT_ENDCAP_INDEX),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, DEFAULT_ENDCAP_INDEX)
      };

      manifoldSeparations.inletIsolator = {
        round: _getScaledValue(_getManifoldSeparationRound, INLET_ISOLATOR_ENDCAP_INDEX),
        square: _getScaledValue(_getManifoldSeparationSquare, INLET_ISOLATOR_ENDCAP_INDEX),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, INLET_ISOLATOR_ENDCAP_INDEX)
      };

      manifoldSeparations.outlet = {
        round: _getScaledValue(_getManifoldSeparationRound, OUTLET_ENDCAP_INDEX),
        square: _getScaledValue(_getManifoldSeparationSquare, OUTLET_ENDCAP_INDEX),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, OUTLET_ENDCAP_INDEX)
      };

      manifoldSeparations.collapsedDefault = {
        round: _getScaledValue(_getManifoldSeparationRound, DEFAULT_ENDCAP_INDEX, true),
        square: _getScaledValue(_getManifoldSeparationSquare, DEFAULT_ENDCAP_INDEX, true),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, DEFAULT_ENDCAP_INDEX, true)
      };

      manifoldSeparations.collapsedInletIsolator = {
        round: _getScaledValue(_getManifoldSeparationRound, INLET_ISOLATOR_ENDCAP_INDEX, true),
        square: _getScaledValue(_getManifoldSeparationSquare, INLET_ISOLATOR_ENDCAP_INDEX, true),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, INLET_ISOLATOR_ENDCAP_INDEX, true)
      };

      manifoldSeparations.collapsedOutlet = {
        round: _getScaledValue(_getManifoldSeparationRound, OUTLET_ENDCAP_INDEX, true),
        square: _getScaledValue(_getManifoldSeparationSquare, OUTLET_ENDCAP_INDEX, true),
        nyloplast: _getScaledValue(_getManifoldSeparationNyloplast, OUTLET_ENDCAP_INDEX, true)
      };

      manifoldSeparations.bendSeparation = getScaledValue(
        scalePixels,
        scaleValue,
        getManifoldBendSeparation(chamberType, chamberRowSpacing, manifoldSizing, manifoldPipeSizes, sepDistance)
      );

      manifoldSeparations.endCapSeparation = getScaledValue(
        scalePixels,
        scaleValue,
        getManifoldEndCapSeparation(manifoldSizing, manifoldPipeSizes, sepDistance)
      );
    }
  } catch (exception) {
    console.warn("An issue occurred while calculating manifold separations");
  }

  return { manifoldSizing, manifoldSeparations };
};



// WEBPACK FOOTER //
// ./src/actions/manifold-actions.js